import styled from 'styled-components';

import FilterRow from 'components/common/FilterRow';
import SearchResult from 'components/search/SearchResult';
import {
	Background,
	BodyInnerWrapper,
	BodyWrapper,
} from 'styles/styled-components/section';

const Creator = () => {
	return (
		<Background>
			<FilterRow />
			<BodyRow>
				<BodyWrapper options={{ scrollbars: { autoHide: 'move', autoHideDelay: 250 } }}>
					<BodyInnerWrapper>
						<SearchResult />
					</BodyInnerWrapper>
				</BodyWrapper>
			</BodyRow>
		</Background>
	);
};

const BodyRow = styled.div`
	width: 100%;
	height: calc(100% - 65px);
	display: flex;
`;

export default Creator;
